import React from 'react';
export function ClaimResolvedDealerTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-302">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-303">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-304" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-305">
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
      }} data-id="element-306">
          <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          margin: '0'
        }} data-id="element-307">
            Claim resolved
          </h1>
          <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#2563eb',
          backgroundColor: '#eff6ff',
          padding: '4px 12px',
          borderRadius: '4px',
          border: '1px solid #bfdbfe'
        }} data-id="element-308">
            {2025240691}
          </span>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '8px'
      }} data-id="element-309">
          Hello <strong data-id="element-310">CANAGRO EXPORTS INC.</strong>,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-311">
          Your claim has been successfully resolved by{' '}
          <strong data-id="element-312">Aisco Europe</strong>. You can review the complete solution
          details in Aisco Workspace.
        </p>

        {/* Resolution Notice */}
        <div style={{
        backgroundColor: '#f0fdf4',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #10b981',
        marginBottom: '32px'
      }} data-id="element-313">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#065f46',
          marginTop: '0',
          marginBottom: '8px'
        }} data-id="element-314">
            ✓ Claim Resolved
          </h3>
          <p style={{
          margin: '0',
          color: '#047857',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-315">
            The claim has been reviewed and multiple solutions have been
            provided. Please see details below.
          </p>
        </div>

        {/* Solutions Provided Header */}
        <h2 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        marginTop: '0',
        marginBottom: '24px'
      }} data-id="element-316">
          Solutions Provided
        </h2>

        {/* Solution 1: Credit Note */}
        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #bfdbfe',
        marginBottom: '16px'
      }} data-id="element-317">
          <div style={{
          backgroundColor: '#ffffff',
          padding: '16px',
          borderRadius: '6px',
          marginBottom: '12px'
        }} data-id="element-318">
            <p style={{
            margin: '0 0 8px 0',
            fontSize: '14px',
            color: '#1e40af',
            fontWeight: '600'
          }} data-id="element-319">
              Credit Note Issued
            </p>
            <p style={{
            margin: '0',
            fontSize: '32px',
            color: '#1e40af',
            fontWeight: '700'
          }} data-id="element-320">
              $1,250.00
            </p>
          </div>
          <p style={{
          margin: '12px 0 16px 0',
          fontSize: '14px',
          color: '#1e40af',
          lineHeight: '1.6'
        }} data-id="element-321">
            A credit note has been issued for the amount above. Download the
            official document from Aisco Workspace.
          </p>
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '10px 20px',
          borderRadius: '6px',
          textDecoration: 'none',
          fontSize: '14px',
          fontWeight: '600'
        }} data-id="element-322">
            Download credit note
          </a>
        </div>

        {/* Solution 2: Replace with Next Shipment */}
        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #bfdbfe',
        marginBottom: '16px'
      }} data-id="element-323">
          <div style={{
          backgroundColor: '#ffffff',
          padding: '16px',
          borderRadius: '6px',
          marginBottom: '12px'
        }} data-id="element-324">
            <p style={{
            margin: '0 0 12px 0',
            fontSize: '14px',
            color: '#1e40af',
            fontWeight: '600'
          }} data-id="element-325">
              Replace with Next Shipment
            </p>
            <div style={{
            borderTop: '1px solid #e5e7eb',
            paddingTop: '12px'
          }} data-id="element-326">
              <p style={{
              margin: '0 0 8px 0',
              fontSize: '12px',
              color: '#6b7280',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontWeight: '600'
            }} data-id="element-327">
                Parts to Replace
              </p>
              <p style={{
              margin: '0',
              fontSize: '13px',
              color: '#1f2937',
              fontFamily: 'monospace',
              lineHeight: '1.8'
            }} data-id="element-328">
                12-0639940 SPREADER 3476MM (136.84") (9360059) G
              </p>
            </div>
          </div>
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          marginBottom: '12px'
        }} data-id="element-329">
            <span style={{
            fontSize: '14px',
            color: '#6b7280',
            fontWeight: '500'
          }} data-id="element-330">
              Shipping Date:
            </span>
            <span style={{
            fontSize: '14px',
            color: '#1e40af',
            fontWeight: '600'
          }} data-id="element-331">
              January 25, 2025
            </span>
          </div>
          <p style={{
          margin: '0',
          fontSize: '14px',
          color: '#1e40af',
          lineHeight: '1.6'
        }} data-id="element-332">
            The replacement parts will be included in your next scheduled
            shipment.
          </p>
        </div>

        {/* Solution 3: Replace by Air Freight */}
        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #bfdbfe',
        marginBottom: '32px'
      }} data-id="element-333">
          <div style={{
          backgroundColor: '#ffffff',
          padding: '16px',
          borderRadius: '6px',
          marginBottom: '12px'
        }} data-id="element-334">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '12px'
          }} data-id="element-335">
              <p style={{
              margin: '0',
              fontSize: '14px',
              color: '#1e40af',
              fontWeight: '600'
            }} data-id="element-336">
                Replace by Air Freight
              </p>
              <span style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#dc2626',
              backgroundColor: '#fee2e2',
              padding: '2px 8px',
              borderRadius: '4px'
            }} data-id="element-337">
                URGENT
              </span>
            </div>
            <div style={{
            borderTop: '1px solid #e5e7eb',
            paddingTop: '12px'
          }} data-id="element-338">
              <p style={{
              margin: '0 0 8px 0',
              fontSize: '12px',
              color: '#6b7280',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontWeight: '600'
            }} data-id="element-339">
                Parts to Replace
              </p>
              <p style={{
              margin: '0',
              fontSize: '13px',
              color: '#1f2937',
              fontFamily: 'monospace',
              lineHeight: '1.8'
            }} data-id="element-340">
                12-0639940 SPREADER 3476MM (136.84") (9360059) G
              </p>
            </div>
          </div>
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          marginBottom: '12px'
        }} data-id="element-341">
            <span style={{
            fontSize: '14px',
            color: '#6b7280',
            fontWeight: '500'
          }} data-id="element-342">
              Shipping Date:
            </span>
            <span style={{
            fontSize: '14px',
            color: '#1e40af',
            fontWeight: '600'
          }} data-id="element-343">
              January 25, 2025
            </span>
          </div>
          <p style={{
          margin: '0',
          fontSize: '14px',
          color: '#1e40af',
          lineHeight: '1.6'
        }} data-id="element-344">
            The replacement parts will be shipped via air freight for expedited
            delivery.
          </p>
        </div>

        {/* Claim Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-345">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-346">
            Claim Information
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-347">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-348">
              <span style={{
              color: '#6b7280'
            }} data-id="element-349">
                Business Unit:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-350">
                Aisco Europe
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-351">
              <span style={{
              color: '#6b7280'
            }} data-id="element-352">
                Claim Type:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-353">
                Technical Issue
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-354">
              <span style={{
              color: '#6b7280'
            }} data-id="element-355">
                Customer:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-356">
                Dimitri Yakolev
              </span>
            </div>
          </div>
        </div>

        {/* Machine Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-357">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-358">
            Machine Details
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-359">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-360">
              <span style={{
              color: '#6b7280'
            }} data-id="element-361">
                Serial Number:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-362">
                002457898987
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-363">
              <span style={{
              color: '#6b7280'
            }} data-id="element-364">
                Installation Date:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-365">
                May 17, 2025
              </span>
            </div>
          </div>
        </div>

        {/* Problem Description */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-366">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-367">
            Problem Description
          </h3>
          <p style={{
          margin: '0',
          color: '#4b5563',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-368">
            Fallo de tarjeta SIM en Icontrol pump por cantidad de dias de
            inactividad. pedimos que nos envien tarjetas SIM de repuesto (en lo
            posible de "Telefonica" ya que es la compania que mejor cobertura
            ofrece en la zona.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-369">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-370">
            View complete solution
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-371">
          You can view all solution details and documentation in Aisco
          Workspace.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-372">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-373">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-374" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}